import { FunctionComponent } from 'react';
import { Link } from 'react-router';
import { PropertyAssociationArea } from '../models/PropertyAssociationArea';

type Props = {
    propertyAssociationId: string;
    value: PropertyAssociationArea;
    returnPath?: string;
};

const PropertyAssociationAreaItem: FunctionComponent<Props> = ({ propertyAssociationId, value, returnPath }) => (
    <Link to={`/${propertyAssociationId}/areas/${value.propertyAssociationAreaId}${returnPath ?? '/'}`} className="boxlist__item boxlist__item--slim boxlist__item--no-image">
        {value.name}
    </Link>
);

export default PropertyAssociationAreaItem;
